//
// Copyright (c) 2011-2017 by Curalate, Inc.
//
//  Custom form validator for urls that checks if they are reachable.
//
//  Usage:
//      <input name="fieldName" type="url" ng-model="scopeValue" ng-required check-url />
//
//  Settings:
//      check-delay: Optional time(ms) to wait after input value changes before submitting the url to the server (Default 400).
//      check-skip-pattern: Optional regex (case ignored). Any url matching will skip the check entirely.
//
//  Description:
//  -   Async submits the url value to the server which tests it is reachable via a simple http GET (no redirects).
//      If the Url is not reachable, it invalidates the form field specified by "fieldName".
//  -   If the form supplies different error messages for $error.required, $error.url, and $error.checkUrl,
//      only one of them will show at a time and they will clear appropriately as the user types/corrects mistakes.

(function() {
  angular.module('curalate')
  .directive('checkUrl', [
    '$timeout',
    '$q',
    'CheckUrlService',
    function(
      $timeout,
      $q,
      CheckUrlService,
    ) {
      return {
        restrict: 'A',
        require: 'ngModel',
        link(scope, elt, attrs, ctrl) {
          const delay = attrs.checkDelay ? attrs.checkDelay : 400;
          const skipRegex = attrs.checkSkipPattern ? new RegExp(attrs.checkSkipPattern, 'i') : null;
          const failRegex = attrs.checkFailPattern ? new RegExp(attrs.checkFailPattern, 'i') : null;

          // use a timeout delay so that we aren't checking on every keystroke
          let timer;
          let httpAbort;

          function cancelPending() {
            if (timer) {
              $timeout.cancel(timer);
              timer = null;
            }

            if (httpAbort) {
              httpAbort.resolve();
              httpAbort = null;
            }
          }

          scope.$watch(attrs.ngModel, (value) => {
            // reset validity of checkUrl on every change to ensure errors are cleared
            ctrl.$setValidity('checkUrl', true);
            ctrl.$setValidity('badUrl', true);
            cancelPending();

            // only check the url if the model is otherwise valid, the url is not blank, and shouldn't be skipped.
            if (!ctrl.$valid || !value) {
              return;
            }

            if (skipRegex && skipRegex.test(value)) {
              return;
            }

            if (failRegex && failRegex.test(value)) {
              ctrl.$setValidity('badUrl', false);
              return;
            }

            httpAbort = $q.defer();
            timer = $timeout(() => {
              CheckUrlService.checkUrl(value).then((data) => {
                ctrl.$setValidity('checkUrl', data.valid);
              });
            }, delay);
          });

          scope.$on('$destroy', () => {
            cancelPending();
          });
        },
      };
    },
  ]);
})();

